<template>
  <div class="users-and-groups-wrapper card">
    <page-header
      title="Add User"
      breadcrumbText="Dashboard >> Settings >> Users and Groups >> Add User"
    />
    <new-user-form />
  </div>
</template>

<script>
import NewUserForm from "./partials/NewUserForm";
export default {
  components: {
    NewUserForm,
  },
};
</script>

<style scoped></style>
